<template>

  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'UserList' }">User</el-breadcrumb-item>
            <el-breadcrumb-item>Add</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form
      ref="user"
      :model="user"
      :rules="rules.user"
      :label-position="label_position">

      <el-form-item label="Login" prop="login">
        <el-input v-model="user.login"></el-input>
      </el-form-item>

      <el-form-item label="First Name" prop="firstName">
        <el-input v-model="user.firstName"></el-input>
      </el-form-item>

      <el-form-item label="Last Name" prop="lastName">
        <el-input v-model="user.lastName"></el-input>
      </el-form-item>

      <el-form-item label="E-Mail" prop="email">
        <el-input v-model="user.email"></el-input>
      </el-form-item>

      <el-form-item label="Password" prop="password">
        <el-input v-model="user.password"></el-input>
      </el-form-item>

      <el-form-item label="Supplier" prop="supplier_id">
        <el-select 
          v-model="user.supplier_id" 
          placeholder="Select Supplier"
          :filterable="true"
          :clearable="false"
          value-key="supplier_id">
          <el-option 
            v-for="supplier in suppliers" 
            :key="supplier.id" 
            :label="supplier.name" 
            :value="supplier.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="User Access" prop="user_access_id">
        <el-select 
          v-model="user.user_access_id" 
          placeholder="Select Access"
          :filterable="true"
          :clearable="false"
          value-key="user_access_id">
          <el-option 
            v-for="item in all_user_access" 
            :key="item.id" 
            :label="item.name" 
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="addUser('user')">Add User</el-button>
      </el-form-item>

    </el-form>

    <pre v-if="config.debug">{{$data}}</pre>

  </div>

</template>

<style>

</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return {
        page_alias: 'Add User',
        page_slug: 'add-user',

        config: Config.config,

        label_position: 'top',
        loading: false,

        user: {
          login: '',
          firstName: '',
          lastName:'',
          email:'',
          created_user_id:'',
          updated_user_id:'',
          user_access_id:'',
          supplier_id:'',
          user_access_id:'',
          password: '',
        },

        suppliers: [],
        all_user_access: [],

        rules: {
          user: {
            login: [
              {required: true, message: 'Please Enter Login', trigger: 'blur'}
            ],
            firstName: [
              {required: true, message: 'Please Enter First Name', trigger: 'blur'}
            ],
            lastName: [
              {required: true, message: 'Please Enter Last Name', trigger: 'blur'}
            ],
            email: [
              {required: true, message: 'Please Enter Email', trigger: 'blur'}
            ],
            portal_url: [
              {required: true, message: 'Please Enter Portal URL', trigger: 'blur'},
              {type: 'url', message: 'Please Enter Valid URL', trigger: 'blur'}
            ],
            supplier_id: [
              {required: true, message: 'Please Choose Supplier', trigger: 'blur'}
            ],
            password: [
              {required: true, message: 'Please Enter Password', trigger: 'blur'},
            ],
          }
        }
      };
    },

    mounted: function() {
      const me = this;
      me.getSuppliers();
      me.getAllUserAccess();
    },

    methods: {
      addUser: function(formName) {
        console.log('Add User Function');
        const me = this;

        me.$refs[formName].validate((valid) => {
          if(valid) {
            var jwt = Utils.decodejwt();

            me.user.updated_user_id = jwt.sub;
            me.user.created_user_id = jwt.sub;

            me.$http.post(me.config.api + 'user', me.user).then(
              response => {
              console.log('Add User Function - Success Posting Data')  

              me.$notify({
                title: 'Success',
                message: 'The User Was Added',
                type: 'success'
              });

              me.$router.push({name: 'UserList'});
            }, response => {
              console.log('Add User Function - Error Posting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      getSuppliers: function() {
        console.log('Get Suppliers Function');
        const me = this;

        me.$http.get(me.config.api + 'supplier', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Suppliers Function - Success Getting Data');

          me.suppliers = response.body.data;
        }, response => {
            console.log('Get Suppliers Function - Error Getting Data');
        });
      },

      getAllUserAccess: function() {
        console.log('Get All User Access Function');
        const me = this;

        me.$http.get(me.config.api + 'access', {params: {no_roles: 1}}).then(
          response => {
          console.log('Get All User Access Function - Success Getting Data');

          me.all_user_access = response.body.data;
        }, response => {
          console.log('Get All User Access Function - Error Getting Data');
        });
      } //LAST METHOD
    }//END METHODS
  }
</script>


// WEBPACK FOOTER //
// src/pages/users/UserAdd.vue